import { colors, font, maxWidth } from "../styles/theme";
import { contacts } from "../data/company";
import { useRequestModal } from "../components/ModalProvider";
import DecorLayer from "../components/DecorLayer";

// CTA-полоса между блоками: призыв оставить заявку + кнопка попапа.
// variant: "light" (сдержанная, светлая) | "red" | "dark".
export default function CtaBand({
  variant = "light",
  title = "Готовы обсудить ваш проект?",
  text = "Оставьте заявку — инженер бесплатно проконсультирует и подготовит расчёт в течение 15 минут.",
  buttonText = "Оставить заявку",
}) {
  const { openRequest } = useRequestModal();
  const dark = variant === "dark";
  const red = variant === "red";
  const light = !dark && !red;

  const bg = dark ? colors.ink : red ? colors.red : colors.bgLight;
  const titleColor = light ? colors.ink : "#fff";
  const textColor = light ? colors.text : "rgba(255,255,255,.85)";
  const phoneColor = light ? colors.ink : "#fff";

  return (
    <section
      style={{
        position: "relative",
        overflow: "hidden",
        background: bg,
        borderTop: light ? "1px solid #e6e9ee" : "none",
        borderBottom: light ? "1px solid #e6e9ee" : "none",
      }}
    >
      {/* Бесшовный топографический узор на фоне (только для светлого варианта) */}
      {light && (
        <DecorLayer src="/cartographer.png" opacity={0.3} size="500px" position="center" repeat="repeat" />
      )}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth,
          margin: "0 auto",
          padding: "40px 22px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 28,
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: "1 1 420px", minWidth: "min(100%,320px)", display: "flex", gap: 18 }}>
          {/* тонкий красный акцент вместо красного фона */}
          {light && <span style={{ flex: "none", width: 4, alignSelf: "stretch", background: colors.red, borderRadius: 3 }} />}
          <div>
            <h2
              style={{
                fontFamily: font.display,
                fontWeight: 700,
                fontSize: "clamp(1.6rem,3vw,2.4rem)",
                lineHeight: 1.1,
                textTransform: "uppercase",
                margin: 0,
                color: titleColor,
              }}
            >
              {title}
            </h2>
            <p style={{ margin: "12px 0 0", fontSize: 16, lineHeight: 1.55, color: textColor, maxWidth: 560 }}>
              {text}
            </p>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 22, flexWrap: "wrap" }}>
          <a
            href={contacts.phoneHref}
            style={{
              textDecoration: "none",
              fontFamily: font.display,
              fontWeight: 700,
              fontSize: "clamp(20px,2.4vw,26px)",
              color: phoneColor,
              whiteSpace: "nowrap",
            }}
          >
            {contacts.phone}
          </a>
          <button
            onClick={openRequest}
            style={{
              background: light ? colors.red : "#fff",
              color: light ? "#fff" : dark ? colors.ink : colors.red,
              border: "none",
              fontFamily: font.display,
              fontWeight: 700,
              fontSize: 15,
              letterSpacing: ".04em",
              textTransform: "uppercase",
              padding: "16px 30px",
              borderRadius: 11,
              cursor: "pointer",
              transition: "background .18s, color .18s",
            }}
            onMouseEnter={(e) => {
              if (light) {
                e.currentTarget.style.background = colors.redDark;
              } else {
                e.currentTarget.style.background = colors.ink;
                e.currentTarget.style.color = "#fff";
              }
            }}
            onMouseLeave={(e) => {
              if (light) {
                e.currentTarget.style.background = colors.red;
              } else {
                e.currentTarget.style.background = "#fff";
                e.currentTarget.style.color = dark ? colors.ink : colors.red;
              }
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </section>
  );
}
